import { useDisclosure } from '@chakra-ui/react';
import React, { useEffect } from 'react';
import { useHistory, useParams } from 'react-router-dom';

import { PageLayout } from '@/components/templates/PageLayout';
import { CmLongLoading, CmScrollBox } from '@/components/uiParts';
import { errorHandler } from '@/lib/ErrorHandler';
import { HttpError } from '@/lib/exception';
import { CanNotUpdateMenuManagementNotice } from '@/pages/menu-managements/components/Alert/CanNotUpdateMenuManagementNotice';
import { MenuManagementEditButtonArea } from '@/pages/menu-managements/components/TopButtonArea';
import { MenuManagementMenusForm } from '@/pages/menu-managements/menus/components/MenuManagementMenusForm';
import { useMenuManagementMenuForm } from '@/pages/menu-managements/menus/hooks/useMenuManagementMenuForm';
import { routes } from '@/router';
import { useMenuManagementDeleteBrandMenu } from '@/services/BrandMenu/hooks';

const MenuManagementMenusEditPage: React.FC = (): JSX.Element => {
  const { id: urlParamsId } = useParams<{ id: string }>();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const history = useHistory();

  const {
    associateBrandSelectInput,
    titleJa,
    memo,
    error,
    searchItems,
    selectedItems,
    searchItemName,
    isSearching,
    targetsHeight,
    initialStringifyFormState,
    isLoading,
    setIsLoading,
    handleUpdate,
    handleInputTitleJa,
    handleInputMemo,
    handleOnDragEnd,
    handleSearchItemNameInput,
    handleAddSelectItems,
    handleDeleteDragItem,
    initializeEditPageState,
  } = useMenuManagementMenuForm();

  const isEdit =
    initialStringifyFormState !==
    JSON.stringify([titleJa, memo, selectedItems]);

  const isDisabledSubmitButton = [
    error.titleJa.isError,
    error.memo.isError,
    !isEdit,
  ].some((error) => error);

  const listUrl = routes.menuManagementMenus.path;

  const handleDelete = () => {
    (async () => {
      try {
        setIsLoading(true);
        await useMenuManagementDeleteBrandMenu(urlParamsId);
        setIsLoading(false);
        alert('メニューを削除しました。');
        history.push(listUrl);
      } catch (error) {
        setIsLoading(false);
        if (error instanceof HttpError && error.status === 400) {
          return alert(error.message);
        }
        // @ts-ignore TS2322
        errorHandler({ error });
      }
    })();
  };

  useEffect(() => {
    (async () => {
      await initializeEditPageState(urlParamsId);
    })();
  }, [urlParamsId]);

  return (
    <PageLayout
      title={routes.menuManagementMenusEdit.title}
      associateBrandSelectInput={{
        ...associateBrandSelectInput,
        isDisabled: true,
      }}
      alert={<CanNotUpdateMenuManagementNotice pageName={'メニュー'} />}
    >
      <MenuManagementEditButtonArea
        name="メニュー"
        isOpenDeleteOpen={isOpen}
        handleOpenDeleteModal={onOpen}
        handleCloseDeleteModal={onClose}
        {...{
          listUrl,
          urlParamsId,
          isDisabledSubmitButton,
          handleUpdate,
          handleDelete,
        }}
      />

      <CmScrollBox height={`calc(100vh - ${targetsHeight}px)`}>
        <MenuManagementMenusForm
          {...{
            titleJa,
            memo,
            error,
            searchItems,
            selectedItems,
            searchItemName,
            associateBrandSelectInput,
            handleInputTitleJa,
            handleInputMemo,
            handleOnDragEnd,
            handleSearchItemNameInput,
            handleAddSelectItems,
            handleDeleteDragItem,
            isSearching,
          }}
          brandSelectValue={associateBrandSelectInput.value?.value ?? ''}
        />
      </CmScrollBox>
      {isLoading && <CmLongLoading />}
    </PageLayout>
  );
};

export default MenuManagementMenusEditPage;
